import { formatNumber as ngFormatNumber } from '@angular/common';
import { getLocale } from 'rev-shared/bootstrap/LocaleContext';

export function formatNumber(value: number, digits: string): string {
	return ngFormatNumber(value, getLocale().bcp47Locale, digits);
}
